module.exports = __webpack_public_path__ + "img/hp-h3.17e818fa.svg";